export const iconFontAwesomeMediaplaybackVolumeLow = (
	<i className="fa-solid fa-volume-low"></i>
);
